import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    active: 'Active',
    paused: 'Paused',
    failed: 'Failed',
    success: 'Success',
    amountSpentValue: '{value} {unit}',
  },
};
